var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bg-br-green font-medium hover:text-white flex items-center justify-center w-full h-12 text-center text-white transition-all rounded-full shadow-lg",attrs:{"disabled":_vm.lineItems.length === 0},on:{"click":_vm.handleCheckout}},[_vm._v("\n  "+_vm._s(_vm.$t('cart.checkOut'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }